import {
  CurrencyEuroIcon,
  DocumentTextIcon,
  ClockIcon,
  CalendarIcon,
  EyeIcon,
  UserGroupIcon,
  AcademicCapIcon,
  HomeIcon,
  GlobeEuropeAfricaIcon,
  ClipboardDocumentCheckIcon,
  NewspaperIcon,
  FlagIcon,
  ClipboardIcon,
} from '@heroicons/react/24/outline';
import { getAssetSrc } from '../utils/assets';

export const listIconMap = {
  CurrencyEuroIcon: <CurrencyEuroIcon className="h-5 w-5" />,
  turnover_bonus: <CurrencyEuroIcon className="h-5 w-5" />,
  DocumentTextIcon: <DocumentTextIcon className="h-5 w-5" />,
  ClockIcon: <ClockIcon className="h-5 w-5" />,
  CalendarIcon: <CalendarIcon className="h-5 w-5" />,
  EyeIcon: <EyeIcon className="h-5 w-5" />,
  UserGroupIcon: <UserGroupIcon className="h-5 w-5" />,
  AcademicCapIcon: <AcademicCapIcon className="h-5 w-5" />,
  continuous_training: <AcademicCapIcon className="h-5 w-5" />,
  HomeIcon: <HomeIcon className="h-5 w-5" />,
  seasonal_accommodation: <HomeIcon className="h-5 w-5" />,
  GlobeEuropeAfricaIcon: <GlobeEuropeAfricaIcon className="h-5 w-5" />,
  paid_trips: <GlobeEuropeAfricaIcon className="h-5 w-5" />,
  NewspaperIcon: <NewspaperIcon className="h-5 w-5" />,
  FlagIcon: <FlagIcon className="h-5 w-5" />,
  ClipboardDocumentCheckIcon: <ClipboardDocumentCheckIcon className="h-5 w-5" />,
  ClipboardIcon: <ClipboardIcon className="h-5 w-5" />,
  psychologist: <img src={getAssetSrc('/utils-assets/psychologist.svg')} alt="" />,
  transportation_card: <img src={getAssetSrc('/utils-assets/transportation_card.svg')} alt="" />,
  gym: <img src={getAssetSrc('/utils-assets/gym.svg')} alt="" />,
  dentist: <img src={getAssetSrc('/utils-assets/dentist.svg')} alt="" />,
  restaurant_discount: <img src={getAssetSrc('/utils-assets/restaurant_discount.svg')} alt="" />,
  workwear: <img src={getAssetSrc('/utils-assets/workwear.svg')} alt="" />,
  CarFront: <img src={getAssetSrc('/utils-assets/car-front.svg')} alt="" />,
  RestTimeSofa: <img src={getAssetSrc('/utils-assets/rest-time-sofa-icon.svg')} alt="" />,
  PartTimeClock: <img src={getAssetSrc('/utils-assets/part-time-clock.svg')} alt="" />,
  FullTimeClock: <img src={getAssetSrc('/utils-assets/full-time-clock.svg')} alt="" />,
  ItalyFlag: <img src={getAssetSrc('/utils-assets/flags/italy.png')} alt="" className="h-5 w-5" />,
  FranceFlag: <img src={getAssetSrc('/utils-assets/flags/france.png')} alt="" className="h-5 w-5" />,
  GermanFlag: <img src={getAssetSrc('/utils-assets/flags/germany.png')} alt="" className="h-5 w-5" />,
  RussiaFlag: <img src={getAssetSrc('/utils-assets/flags/russia.png')} alt="" className="h-5 w-5" />,
  UKFlag: <img src={getAssetSrc('/utils-assets/flags/uk.png')} alt="" className="h-5 w-5" />,
  SpainFlag: <img src={getAssetSrc('/utils-assets/flags/spain.png')} alt="" className="h-5 w-5" />,
};
export const ratingIconMap = {
  'rating-currency-icon': (
    <g clipPath="url(#clip0_214_8672)">
      <path
        d="M44.9135 29.7874C49.5597 34.4336 49.5597 41.9666 44.9135 46.6127C40.2673 51.2589 32.7343 51.2589 28.0882 46.6127C23.442 41.9665 23.442 34.4336 28.0882 29.7874C32.7344 25.1412 40.2673 25.1412 44.9135 29.7874Z"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.2768 41.978C38.1903 44.0646 34.8088 44.0646 32.7222 41.978C30.6356 39.8914 30.6356 36.5099 32.7222 34.4233C34.8088 32.3368 38.1903 32.3368 40.2768 34.4233"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5022 36.7256H30.0918"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5022 39.6746H30.0918"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
  'rating-graph-icon': (
    <g clipPath="url(#clip0_219_8807)">
      <path
        d="M37.3333 29.3333H48M48 29.3333V40M48 29.3333L37.3333 40L32 34.6666L24 42.6666"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
  'rating-clock-icon': (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M37 30v8h6m6 0a12 12 0 1 1-24 0 12 12 0 0 1 24 0"
      stroke="#693EB5"
    />
  ),
  'ellipse-image': '/ellipse-image.jpg',
};

export const ratingCorMap = {
  1: {
    x: 8,
    y: 50,
  },
  2: {
    x: 6,
    y: 26,
  },
  3: {
    x: 35,
    y: 4,
  },
  4: {
    x: 66,
    y: 26,
  },
  5: {
    x: 64,
    y: 50,
  },
};
